import { generateDefaultSelectors } from "@/redux/selectors.utils";
import { IState } from "@/redux/store.types";
import { getApiDataState } from "@/redux/utils";

import { $OrderDetailModuleName } from "./orderDetail.types";

const { isLoading } = generateDefaultSelectors($OrderDetailModuleName);

const getState = (state: IState) => {
    return getApiDataState(state, $OrderDetailModuleName);
};

const getOrderId = (state: IState) => {
    return getOrder(state)?.orderId;
};

const getTransportReservationToken = (state: IState) => {
    return getOrder(state)?.reservationToken;
};

const getOrder = (state: IState) => getState(state)?.data?.order;

export { getOrder, getOrderId, getTransportReservationToken, isLoading };
